import React, {PureComponent} from 'react';
import TranslatedText from '../../atoms/TranslatedText';
import background from './background.jpg';
import animation from './true-digital-range.png';
import Apng from '../../atoms/Apng';

import './TrueDigitalRange.css';

export default class TrueDigitalRange extends PureComponent {
    render() {
        const style = {backgroundImage: `url(${background})`};
        return (
            <article className="TrueDigitalRange" style={style}>
                <div className="TrueDigitalRange-top">
                    <h3 className="top-title">
                        <TranslatedText tag="true_digital.range.title" />
                    </h3>
                </div>
                <div className="TrueDigitalRange-center">
                    <h4 className="description">
                        <TranslatedText tag="true_digital.range.description" />
                    </h4>
                </div>
                <div className="TrueDigitalRange-bottom">
                    <div className="TrueDigitalRangeLabel">
                        <TranslatedText tag="true_digital.range.label" />
                    </div>
                    <Apng
                        src={`${animation}?v=${Math.random()}`}
                        alt=""
                        draggable="false"
                    />
                </div>
            </article>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/trueDigital/TrueDigitalRange.js